import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

export const getUserEventCount = async (userId, fromDate, toDate) => {
    try {
        const response = await axios.get(
            `${API_BASE_URL}/user-cta/event-count/${userId}`,
            {
                params: {
                    from_date: fromDate,
                    to_date: toDate,
                },
            }
        );

        return response.data;
    } catch (error) {
        console.error("Error fetching user event count:", error);
        throw error;
    }
};

export const postUserUsageTime = async (userId, seconds) => {
    const response = await axios.post(
        `${API_BASE_URL}/user-usage-time`,
        {
            user_id: userId,
            seconds: seconds,
        },
        {
            headers: {
                "Content-Type": "application/json",
            },
        }
    );

    return response.data;
};

export const getUserCTAHistory = async (
    userId,
    event,
    fromDate,
    toDate
) => {

    try {

        const response = await axios.get(
            `${API_BASE_URL}/user-cta/${userId}`,
            {
                params: {
                    event,
                    from_date: fromDate,
                    to_date: toDate,
                },
            }
        );

        return response.data;

    } catch (error) {

        console.error("Error fetching CTA history:", error);
        throw error;
    }
};


//user analytics :Activity Analytics 
export const getAnalyticsData = async (
    userId,
    duration 
) => {

    try {
     
        const response = await axios.get(
            `${API_BASE_URL}/analytics-data/${userId}`,
            {
                params: {
                    duration,
                },
            }
        );

        return response.data;

    } catch (error) {

        console.error(
            "Error fetching analytics data:",
            error
        );

        throw error;
    }
};